export default "__VITE_ASSET__WxMTS8$s__"